/**
 * This class is responsible for running the Product Details page
 */
const opts = {
    staticData: true
};
const client = supafolio("", "", "kube-publishing-uk", opts);


function getQueryParameterValue(param) {
    const url_string = window.location.href,
        url = new URL(url_string);

    return url.searchParams.get(param)
}

function getTemplate(templateName) {
    return document.querySelector('#' + templateName + '-template').innerHTML;
}

class AuthorDetails {
    constructor(contributorID) {
        this.contributorID = contributorID;
        this.authorBooksObjectIds = [];
    }


    /**
     * @returns {*}
     */
    async run() {
        try {
            client.addDetailsWidget({
                objectID: `${this.contributorID}`,
                source: "contributors",
                container: "#contributor-details",
                resultHandler: this.contributorResultHandler.bind(this),
                static: {
                    contributors: true
                },
                templates: {
                    item: getTemplate('contributor-details'),
                    empty: getTemplate('no-results')
                },
            }).then(() => {
                addEventListeners();
            });
        } catch( err ) {
            console.log(err);
        }
    }

    contributorResultHandler(author) {
        this.author = author;
        return author;
    }
}

function addEventListeners() {
    if( document.getElementById('contributor-details') !== null ) {
        document.getElementById('contributor-details').style.display = 'block';
    }
}

document.addEventListener("DOMContentLoaded", () => {
    if( document.getElementById('contributor-details') !== null ) {
        const authordetails = new AuthorDetails(getQueryParameterValue("contributorID"));
        authordetails.run();
    }
});